






































































import Vue from 'vue'
import ProductOptions from '@/stockLibrary/components/product/ProductOptions.vue'
import PreviewDefaultModal from '@/stockLibrary/components/PreviewDefaultModal.vue'

import { ProductDetail } from '@/stockLibrary/queries/types'

type ViewTarget = 'product' | 'category'

export default Vue.extend({
  components: {
    ProductOptions,
    PreviewDefaultModal
  },
  props: {
    productDetail: {
      type: Object as () => ProductDetail,
      required: true
    },
    isDefaultDesign: {
      type: Boolean,
      required: true
    },
    categoryId: {
      type: String,
      required: true
    },
    userDesignId: {
      type: String,
      required: true
    },
    selectedFirstOption: {
      type: String,
      required: true
    },
    categoryName: {
      type: String,
      required: true
    }
  },
  data(): {
    showPreviewDefaultModal: boolean
    viewTarget: ViewTarget
  } {
    return {
      showPreviewDefaultModal: false,
      viewTarget: 'product'
    }
  },
  computed: {
    productUrl(): string {
      let url = `${this.productDetail.product.url}?firstOptionId=${this.selectedFirstOption}`
      return !this.isDefaultDesign
        ? url += `&designVersion=${this.userDesignId}`
        : url
    },
    categoryUrl(): string {
      let url = `/search?category=${this.categoryId}`
      return !this.isDefaultDesign
        ? url += `&designVersion=${this.userDesignId}`
        : url
    }
  },
  methods: {
    openProduct() {
      if (!this.isDefaultDesign) {
        return window.location.href = this.productUrl
      }
      this.viewTarget = 'product'
      this.showPreviewDefaultModal = true
    },
    openCategory() {
      if (!this.isDefaultDesign) {
        return window.location.href = this.categoryUrl
      }
      this.viewTarget = 'category'
      this.showPreviewDefaultModal = true
    },
    updateSkuEditPattern(firstOptionId: string) {
      this.$emit('onChangeFirstOption', firstOptionId)
    }
  }
})
